const cmpSwiper = new Swiper('.cmpSwiper', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    breakpoints: {
        1024: {
            navigation: {
                prevEl: '.cmp-prev',
                nextEl: '.cmp-next'
            },
            pagination: false, // vypne pagination na desktop
        }
    },
    on: {
        slideChange(sw) {
            setCmpActive(sw.activeIndex);
        }
    }
});
